import { render, staticRenderFns } from "./BrandListBlock.vue?vue&type=template&id=2efaa92f&scoped=true&"
import script from "./BrandListBlock.vue?vue&type=script&lang=js&"
export * from "./BrandListBlock.vue?vue&type=script&lang=js&"
import style0 from "./BrandListBlock.vue?vue&type=style&index=0&id=2efaa92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efaa92f",
  null
  
)

export default component.exports